import { t } from "i18next";
import { useEffect, useState } from "react";

import { useCompanySettings } from "../../../../hooks/useCompanySettings";
import { putCompanySettings } from "../../../../store/settingsStore";
import { useAppDispatch } from "../../../../store/store";
import ChipsAutocomplete from "../../../shared/ChipsAutocomplete";

export const HiddenStockLinesOnStatement = () => {
    const { getCompanySettings } = useCompanySettings();
    const [selectedLines, setSelectedLines] = useState<string[]>([]);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const settingValue: string[] | null = getCompanySettings("hidden_stock_lines_on_statement");
        setSelectedLines((settingValue ?? []).map((setting) => t(`AdminPanel.Inventory.${setting}`)));
    }, [getCompanySettings]);

    const options = [
        { name: t("AdminPanel.Inventory.InventoryAtBeginning"), disabled: true },
        { id: "PrintedInventory", name: t("AdminPanel.Inventory.PrintedInventory") },
        { id: "SentInventory", name: t("AdminPanel.Inventory.SentInventory") },
        { id: "ReturnedInventory", name: t("AdminPanel.Inventory.ReturnedInventory") },
        { id: "NetSales", name: t("AdminPanel.Inventory.NetSales") },
        { id: "PressInventory", name: t("AdminPanel.Inventory.PressInventory") },
        { id: "ScrappedInventory", name: t("AdminPanel.Inventory.ScrappedInventory") },
        { name: t("AdminPanel.Inventory.InventoryAtEnd"), disabled: true },
    ];

    const handleSetCompanySetting = (selectedLines: string[] | ((prevState: string[]) => string[])) => {
        if (typeof selectedLines === "function") return;

        setSelectedLines(selectedLines);
        dispatch(
            putCompanySettings([
                {
                    settingsName: "hidden_stock_lines_on_statement",
                    settingsValue: JSON.stringify(
                        selectedLines.map((line) => options.find((o) => o.name === line)?.id),
                    ),
                },
            ]),
        );
    };

    return (
        <div className="mb-2">
            <ChipsAutocomplete
                options={options.map((option, index) => ({ ...option, id: index }))}
                label={t("AdminPanel.Inventory.SelectLines")}
                noOptionsText={t("CompanySettings.NoChannelsAvailable")}
                filter="channels"
                chosenTags={selectedLines}
                setChosenTags={handleSetCompanySetting}
            />
        </div>
    );
};
